import React, { useMemo, useState } from 'react';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import Footer from '../components/footer';

// Cyber Jagrit Bharat 2025
import Awarness1 from '../assets/Gallery/CyberJagrit/Awarness1.jpg';
import Awarness2 from '../assets/Gallery/CyberJagrit/Awarness2.jpg';
import Awarness3 from '../assets/Gallery/CyberJagrit/Awarness3.jpg';
import Awarness4 from '../assets/Gallery/CyberJagrit/Awarness4.jpg';
import Awarness5 from '../assets/Gallery/CyberJagrit/Awarness5.jpg';
import Memathon1 from '../assets/Gallery/CyberJagrit/Memathon1.jpg';
import Memathon2 from '../assets/Gallery/CyberJagrit/Memathon2.jpg';
import Memathon3 from '../assets/Gallery/CyberJagrit/Memathon3.jpg';
import Memathon4 from '../assets/Gallery/CyberJagrit/Memathon4.jpg';
import Memathon5 from '../assets/Gallery/CyberJagrit/Memathon5.jpg';
import Stimulator1 from '../assets/Gallery/CyberJagrit/Stimulator1.jpg';
import Stimulator2 from '../assets/Gallery/CyberJagrit/Stimulator2.jpg';
import Stimulator3 from '../assets/Gallery/CyberJagrit/Stimulator3.jpg';
import Stimulator4 from '../assets/Gallery/CyberJagrit/Stimulator4.jpg';
import Stimulator5 from '../assets/Gallery/CyberJagrit/Stimulator5.jpg';
import Nukad1 from '../assets/Gallery/CyberJagrit/Nukad1.JPG';
import Nukad2 from '../assets/Gallery/CyberJagrit/Nukad2.JPG';
import Nukad3 from '../assets/Gallery/CyberJagrit/Nukad3.JPG';
import Nukad4 from '../assets/Gallery/CyberJagrit/Nukad4.JPG';
import Nukad5 from '../assets/Gallery/CyberJagrit/Nukad5.JPG';
import Quiz1 from '../assets/Gallery/CyberJagrit/IMG_20251016_110021.jpg';
import Quiz2 from '../assets/Gallery/CyberJagrit/IMG_20251016_110036.jpg';
import Quiz3 from '../assets/Gallery/CyberJagrit/IMG_2519.jpg';

// National Seminar Day 1
import a from '../assets/Gallery/National_Seminar/day 1/1.jpg';
import b from '../assets/Gallery/National_Seminar/day 1/2.jpg';
import c from '../assets/Gallery/National_Seminar/day 1/3.jpg';
import d from '../assets/Gallery/National_Seminar/day 1/4.jpg';
import e from '../assets/Gallery/National_Seminar/day 1/5.jpg';
import f from '../assets/Gallery/National_Seminar/day 1/6.jpg';
import g from '../assets/Gallery/National_Seminar/day 1/7.jpg';
import h from '../assets/Gallery/National_Seminar/day 1/8.jpg';
import i from '../assets/Gallery/National_Seminar/day 1/9.jpg';
import j from '../assets/Gallery/National_Seminar/day 1/10.jpg';
import k from '../assets/Gallery/National_Seminar/day 1/11.jpg';

// National Seminar Day 2
import day2a from '../assets/Gallery/National_Seminar/day 2/a.jpg';
import day2b from '../assets/Gallery/National_Seminar/day 2/b.jpg';
import day2c from '../assets/Gallery/National_Seminar/day 2/c.jpg';
import day2d from '../assets/Gallery/National_Seminar/day 2/d.jpg';
import day2e from '../assets/Gallery/National_Seminar/day 2/e.jpg';
import day2f from '../assets/Gallery/National_Seminar/day 2/f.jpg';
import day2g from '../assets/Gallery/National_Seminar/day 2/g.jpg';
import day2h from '../assets/Gallery/National_Seminar/day 2/h.jpg';
import day2i from '../assets/Gallery/National_Seminar/day 2/i.jpg';
import day2j from '../assets/Gallery/National_Seminar/day 2/j.jpg';
import day2k from '../assets/Gallery/National_Seminar/day 2/k.jpg';
import day2l from '../assets/Gallery/National_Seminar/day 2/l.jpg';

// Inauguration
import inag1 from '../assets/Gallery/Inagruation/inag1.jpg';
import inag2 from '../assets/Gallery/Inagruation/inag2.jpg';
import inag3 from '../assets/Gallery/Inagruation/inag3.jpg';

// Dev-Spark
import devspark1 from '../assets/Gallery/DevSpark/DEVSPARK1.jpg';
import devspark2 from '../assets/Gallery/DevSpark/DEVSPARK2.jpg';
import devspark3 from '../assets/Gallery/DevSpark/DEVSPARK3.jpg';
import devspark4 from '../assets/Gallery/DevSpark/DEVSPARK4.jpg';
import devspark5 from '../assets/Gallery/DevSpark/DEVSPAR5.jpg';
import devspark6 from '../assets/Gallery/DevSpark/DEVSPARK6.jpg';
import devspark8 from '../assets/Gallery/DevSpark/DEVSARK8.jpg';
import devspark10 from '../assets/Gallery/DevSpark/DEVSPARK10.jpg';
import devspark11 from '../assets/Gallery/DevSpark/DEVSAPRK11.jpg';
import devspark12 from '../assets/Gallery/DevSpark/DEVSAPRK12.jpg';
import devspark13 from '../assets/Gallery/DevSpark/DEVSAPRK13.jpg';
import devspark15 from '../assets/Gallery/DevSpark/DEVSPARK15.jpg';
import devspark16 from '../assets/Gallery/DevSpark/DEVSAPRK16.jpg';

// Hack-To-Hire
import hacktohire1 from '../assets/Gallery/HackToHire/hack to hire1.jpg';
import hacktohire2 from '../assets/Gallery/HackToHire/hacktohire2.jpg';
import hacktohire3 from '../assets/Gallery/HackToHire/hacktohire3.jpg';
import hacktohire4 from '../assets/Gallery/HackToHire/hacktohire4.jpg';
import hacktohire5 from '../assets/Gallery/HackToHire/hacktohire5.jpg';
import hacktohire6 from '../assets/Gallery/HackToHire/hacktohire6.jpg';
import hacktohire7 from '../assets/Gallery/HackToHire/hacktohore7.jpg';
import hacktohire8 from '../assets/Gallery/HackToHire/hacktohire8.jpg';

const galleryData = [
  {
    id: 1,
    title: 'Hack-To-Hire Ideathon 2025',
    subtitle: '13 November 2025 | Jharkhand edition ideathon snapshots from CUJ',
    accent: 'from-amber-500 to-orange-700',
    images: [
      { src: hacktohire1, alt: 'Hack-To-Hire ideathon opening photo' },
      { src: hacktohire2, alt: 'Hack-To-Hire team presenting ideas' },
      { src: hacktohire3, alt: 'Hack-To-Hire mentor interaction' },
      { src: hacktohire4, alt: 'Hack-To-Hire felicitation moment' },
      { src: hacktohire5, alt: 'Hack-To-Hire team and event board' },
      { src: hacktohire6, alt: 'Hack-To-Hire winners receiving recognition' },
      { src: hacktohire7, alt: 'Hack-To-Hire team with certificates' },
      { src: hacktohire8, alt: 'Hack-To-Hire finalists group photo' }
    ]
  },
  {
    id: 2,
    title: 'Cyber Jagrit Bharat 2025',
    subtitle: '16, 17 and 26 October 2025 | Awareness, competitions and practical sessions',
    accent: 'from-fuchsia-500 to-pink-700',
    images: [
      { src: Awarness1, alt: 'Cyber Jagrit awareness desk activity' },
      { src: Awarness2, alt: 'Cyber Jagrit awareness interaction' },
      { src: Awarness3, alt: 'Cyber Jagrit awareness outreach' },
      { src: Awarness4, alt: 'Cyber Jagrit student awareness desk' },
      { src: Awarness5, alt: 'Cyber Jagrit campus awareness session' },
      { src: Memathon1, alt: 'Cyber Jagrit memeathon participation' },
      { src: Memathon2, alt: 'Cyber Jagrit memeathon student entry' },
      { src: Memathon3, alt: 'Cyber Jagrit memeathon highlights' },
      { src: Memathon4, alt: 'Cyber Jagrit memeathon creative showcase' },
      { src: Memathon5, alt: 'Cyber Jagrit memeathon winners' },
      { src: Stimulator1, alt: 'Cyber Jagrit simulator demonstration' },
      { src: Stimulator2, alt: 'Cyber Jagrit cybersecurity simulation' },
      { src: Stimulator3, alt: 'Cyber Jagrit practical simulator session' },
      { src: Stimulator4, alt: 'Cyber Jagrit ethical hacking demo' },
      { src: Stimulator5, alt: 'Cyber Jagrit simulator lab activity' },
      { src: Nukad1, alt: 'Cyber Jagrit nukkad natak performance' },
      { src: Nukad2, alt: 'Cyber Jagrit street play scene' },
      { src: Nukad3, alt: 'Cyber Jagrit social message performance' },
      { src: Nukad4, alt: 'Cyber Jagrit audience engagement through drama' },
      { src: Nukad5, alt: 'Cyber Jagrit student performers' },
      { src: Quiz1, alt: 'Cyber Jagrit online quiz session' },
      { src: Quiz2, alt: 'Cyber Jagrit quiz participation' },
      { src: Quiz3, alt: 'Cyber Jagrit quiz highlights' }
    ]
  },
  {
    id: 3,
    title: 'Dev-Spark 2025',
    subtitle: '18 September 2025 | Google Cloud and community-focused pre-DevFest event',
    accent: 'from-cyan-500 to-blue-700',
    images: [
      { src: devspark1, alt: 'Dev-Spark presentation in auditorium' },
      { src: devspark2, alt: 'Dev-Spark speaker session' },
      { src: devspark3, alt: 'Dev-Spark participants in auditorium' },
      { src: devspark4, alt: 'Dev-Spark projector content' },
      { src: devspark5, alt: 'Dev-Spark stage moment' },
      { src: devspark6, alt: 'Dev-Spark felicitation' },
      { src: devspark8, alt: 'Dev-Spark group photo with participants' },
      { src: devspark10, alt: 'Dev-Spark faculty address' },
      { src: devspark11, alt: 'Dev-Spark event highlights' },
      { src: devspark12, alt: 'Dev-Spark lamp lighting ceremony' },
      { src: devspark13, alt: 'Dev-Spark event capture' },
      { src: devspark15, alt: 'Dev-Spark technical presentation' },
      { src: devspark16, alt: 'Dev-Spark interactive session' }
    ]
  },
  {
    id: 4,
    title: 'National Seminar Day 2',
    subtitle: '28 February 2025 | Hands-on talks, demos and valedictory highlights',
    accent: 'from-teal-500 to-cyan-700',
    images: [
      { src: day2a, alt: 'National Seminar Day 2 workshop session' },
      { src: day2b, alt: 'National Seminar Day 2 hands-on training' },
      { src: day2c, alt: 'National Seminar Day 2 student interaction' },
      { src: day2d, alt: 'National Seminar Day 2 awards' },
      { src: day2e, alt: 'National Seminar Day 2 closing' },
      { src: day2f, alt: 'National Seminar Day 2 workshop floor' },
      { src: day2g, alt: 'National Seminar Day 2 speaker session' },
      { src: day2h, alt: 'National Seminar Day 2 audience engagement' },
      { src: day2i, alt: 'National Seminar Day 2 presentation' },
      { src: day2j, alt: 'National Seminar Day 2 valedictory' },
      { src: day2k, alt: 'National Seminar Day 2 event moment' },
      { src: day2l, alt: 'National Seminar Day 2 certificates and closing' }
    ]
  },
  {
    id: 5,
    title: 'National Seminar Day 1',
    subtitle: '27 February 2025 | Opening sessions, keynotes and technical presentations',
    accent: 'from-indigo-500 to-violet-700',
    images: [
      { src: a, alt: 'National Seminar Day 1 opening session' },
      { src: b, alt: 'National Seminar Day 1 keynote' },
      { src: c, alt: 'National Seminar Day 1 technical session' },
      { src: d, alt: 'National Seminar Day 1 panel discussion' },
      { src: e, alt: 'National Seminar Day 1 networking break' },
      { src: f, alt: 'National Seminar Day 1 student presentation' },
      { src: g, alt: 'National Seminar Day 1 workshop' },
      { src: h, alt: 'National Seminar Day 1 interaction' },
      { src: i, alt: 'National Seminar Day 1 moments' },
      { src: j, alt: 'National Seminar Day 1 audience' },
      { src: k, alt: 'National Seminar Day 1 closing moments' }
    ]
  },
  {
    id: 6,
    title: 'CSI Inauguration',
    subtitle: '29 November 2024 | Founding moments of CSI CUJ Student Chapter',
    accent: 'from-sky-500 to-blue-700',
    images: [
      { src: inag1, alt: 'CSI inauguration ceremony' },
      { src: inag2, alt: 'CSI inauguration group photo' },
      { src: inag3, alt: 'CSI inauguration address' }
    ]
  }
];

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredData = useMemo(() => {
    if (selectedCategory === 'all') {
      return galleryData;
    }

    return galleryData.filter((category) => category.id === Number(selectedCategory));
  }, [selectedCategory]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-slate-100">
      <Header />
      <Navbar />

      <main className="pt-32 sm:pt-40 md:pt-48 lg:pt-56">
        <div className="container mx-auto px-4 py-8">
          <section className="mb-12 rounded-3xl border border-slate-200 bg-white/90 p-8 text-center shadow-lg backdrop-blur-sm">
            <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-csi-blue">CSI CUJ Moments</p>
            <h1 className="text-4xl font-extrabold text-slate-900 md:text-6xl">Events Gallery</h1>
            <p className="mx-auto mt-4 max-w-3xl text-base text-slate-600 md:text-lg">
              Explore key moments from our seminars, workshops, ideathons, and student-led initiatives.
            </p>
          </section>

          <section className="mb-10">
            <div className="flex flex-wrap justify-center gap-3">
              <button
                onClick={() => setSelectedCategory('all')}
                className={`rounded-full px-5 py-2 text-sm font-semibold transition ${
                  selectedCategory === 'all'
                    ? 'bg-csi-blue text-white shadow-md'
                    : 'bg-white text-csi-blue border border-csi-blue/40 hover:border-csi-blue'
                }`}
              >
                All Events
              </button>
              {galleryData.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(String(category.id))}
                  className={`rounded-full px-5 py-2 text-sm font-semibold transition ${
                    selectedCategory === String(category.id)
                      ? 'bg-csi-blue text-white shadow-md'
                      : 'bg-white text-csi-blue border border-csi-blue/40 hover:border-csi-blue'
                  }`}
                >
                  {category.title}
                </button>
              ))}
            </div>
          </section>

          <section className="space-y-12">
            {filteredData.map((category) => (
              <article key={category.id} className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-lg">
                <div className={`bg-gradient-to-r ${category.accent} p-6 text-white`}>
                  <h2 className="text-2xl font-bold md:text-3xl">{category.title}</h2>
                  <p className="mt-2 text-sm md:text-base text-white/90">{category.subtitle}</p>
                </div>

                <div className="grid gap-4 p-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {category.images.map((image, index) => (
                    <button
                      key={`${category.id}-${index}`}
                      onClick={() => setSelectedImage(image)}
                      className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-slate-100 text-left"
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        loading="lazy"
                        className="h-56 w-full object-cover transition duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                        <p className="text-xs font-medium text-white/95 sm:text-sm">{image.alt}</p>
                      </div>
                    </button>
                  ))}
                </div>
              </article>
            ))}
          </section>
        </div>
      </main>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-h-full w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute right-3 top-3 z-10 rounded-full bg-black/60 px-3 py-1 text-sm font-bold text-white hover:bg-black/80"
            >
              Close
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-h-[80vh] w-full rounded-xl object-contain"
            />
            <p className="mt-3 text-center text-sm text-white/90 md:text-base">{selectedImage.alt}</p>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery;
